import { Color, Mesh, MeshPhysicalMaterial } from 'three';

export const changeAllMeshsColor = (color: Color, meshList: Mesh[]): void => {
  meshList.forEach(mesh => {
    const material = mesh.material as MeshPhysicalMaterial;
    material.color = color;
  });
};
